module.exports = __webpack_public_path__ + "static/img-9-581f695145abdee64ecf72cd42b215a0.jpeg";